import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { PlayerPoints, TournamentConfig } from '../../../database.schema';

const IndividualWrapper = styled.div`
  margin: 0.5rem 1rem 0;
  display: flex;
  justify-content: center;
  table,
  th,
  td {
    border-collapse: collapse;
  }
`;

const IndividualPointsHeader = styled.th`
  width: 8rem;
  font-weight: bold;
  padding: 0 0 0.25rem;
  font-size: 18px;
`;

const Points = styled.td`
  text-align: right;
  padding-right: 2rem;
`;
const Centred = styled.td`
  text-align: center;
  min-width: 2.5rem;
`;
const Position = styled.th`
  min-width: 1.25rem;
`;

type Props = {
  individualPoints?: Array<PlayerPoints>;
  config: TournamentConfig;
};

export const TeamGameIndividualStandings: FC<Props> = ({ individualPoints, config }): JSX.Element => {
  return (
    <IndividualWrapper>
      <table>
        <thead>
          <tr data-testid="individual-tabel-headings">
            <Position></Position>
            <th></th>
            <IndividualPointsHeader>Points(Avg)</IndividualPointsHeader>
            {config.showLongestDrive && <th>Longest Drive</th>}
            {config.showNearestThePin && <th>NTP</th>}
            {config.showNearestThePinIn2 && <th>NTPIn2</th>}
          </tr>
        </thead>
        <tbody>
          {individualPoints?.map((player: PlayerPoints, index: number) => (
            <tr key={`individual-${player.player.id}-${index}`}>
              <td data-testid={`ind-position-${index}`}>{player.position}</td>
              <td data-testid={`ind-player-${index}`}>{player.player.nickName}</td>
              <Points data-testid={`ind-points-${index}`}>{`${player.points} (${player.average})`}</Points>
              {config.showLongestDrive && <Points data-testid={`ld-totals-${player.player.nickName}`}>{player.longestDrive ? player.longestDrive : ''}</Points>}
              {config.showNearestThePin && <Centred data-testid={`ntp-totals-${player.player.nickName}`}>{player.nearestThePin ? player.nearestThePin : ''}</Centred>}
              {config.showNearestThePinIn2 && <Centred data-testid={`ntpIn2-totals-${player.player.nickName}`}>{player.nearestThePinIn2 ? player.nearestThePinIn2 : ''}</Centred>}
            </tr>
          ))}
        </tbody>
      </table>
    </IndividualWrapper>
  );
};
